import React, { createContext, useContext } from 'react'
import { Auth } from '@firebase/auth'
import { AuthProviderProps } from './type'

const AuthContext = createContext({} as Auth)

export const AuthProvider = ({ children, auth }: AuthProviderProps) => {
	return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>
}

export const useAuth = () => useContext(AuthContext)
